import { useHouseholdSizeSerializer } from './useHouseholdSerializer';
import { chainPrismicContentSerializers } from '@monofront/business/utils/chainPrismicContentSerializers';
import { useFreeDeliverySerializer } from '@hooks/usePrismicContentSerializer/useFreeDeliverySerializer';
import { useMemo } from 'react';

export const usePrismicContentSerializer = () => {
  const householdSizeSerializer = useHouseholdSizeSerializer();
  const freeDeliverySerializer = useFreeDeliverySerializer();

  // To add a new serializer, add it as the next parameter for chainPrismicContentSerializers
  // Serializers are run sequentially and take return from previous one as their own parameters.
  return useMemo(
    () =>
      chainPrismicContentSerializers(
        householdSizeSerializer,
        freeDeliverySerializer,
      ),
    [householdSizeSerializer, freeDeliverySerializer],
  );
};
